import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0978 = React.lazy(
  () => import('./symbols/0978_family_relationship_father_mother_child')
);
const Symbol0979 = React.lazy(() => import('./symbols/0979_family_relationship_mother_child'));
const Symbol0980 = React.lazy(() => import('./symbols/0980_relationship_couple_love_marriage'));
const Symbol0981 = React.lazy(
  () => import('./symbols/0981_relationship_couple_love_break_divorce')
);
const Symbol0982 = React.lazy(
  () => import('./symbols/0982_relationship_ring_love_marriage_engage_fiance')
);
const Symbol0983 = React.lazy(() => import('./symbols/0983_child_baby_stroller'));
const Symbol0984 = React.lazy(() => import('./symbols/0984_child_toy_playground_horse'));
const Symbol0985 = React.lazy(() => import('./symbols/0985_child_baby_toys'));

export interface IProps {}

const Family: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0978_family_relationship_father_mother_child" symbol={<Symbol0978 />} />
      <LazySymbol id="0979_family_relationship_mother_child" symbol={<Symbol0979 />} />
      <LazySymbol id="0980_relationship_couple_love_marriage" symbol={<Symbol0980 />} />
      <LazySymbol id="0981_relationship_couple_love_break_divorce" symbol={<Symbol0981 />} />
      <LazySymbol id="0982_relationship_ring_love_marriage_engage_fiance" symbol={<Symbol0982 />} />
      <LazySymbol id="0983_child_baby_stroller" symbol={<Symbol0983 />} />
      <LazySymbol id="0984_child_toy_playground_horse" symbol={<Symbol0984 />} />
      <LazySymbol id="0985_child_baby_toys" symbol={<Symbol0985 />} />
    </>
  );
});

Family.displayName = 'Family';

export default Family;
